import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/pic.jpg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Find Me On</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/tolunaykan"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/tolunaykan"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/tolunay-kand%C4%B1rmaz-12a734158/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/tolunaykan"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} style={{height: 300, borderRadius: 400}} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Let Me <span className="purple"> Introduce </span> Myself
            </h1>
            <p className="home-about-body">
              I have graduated from <b className="purple">Istanbul Technical University</b> majoring  <b className="purple">Computer Engineering</b> in the summer of 2021.
              I have been developing <b className="purple">mobile applications</b> on <b className="purple">Google Play Store</b> and <b className="purple">App Store</b> by myself for more than ten years.
              <br/>
              Currently, I have been working at <a href={"https://trendyol.com"} style={{ textDecoration: 'none' }}><b className="purple">Trendyol</b></a> as a <b className="purple">backend developer</b>.
            </p>
          </Col>

        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
